import { CToast, CToastBody, CToastClose } from "@coreui/react"
export const Toast = (props) => {
    return (
        <CToast
            {...props}
            style={{ zIndex: 1100 }}
            className="text-white align-items-center mt-4 position-fixed top-0 end-0"
        >
            <div className="d-flex">
                <CToastBody>{props.message}</CToastBody>
                <CToastClose className="me-2 m-auto" white />
            </div>
        </CToast>
    )
}